import React, { Component } from 'react';
import {connect} from 'react-redux';
import _get from 'lodash/get';
import styles from './Members.scss';
import PropertyCardSearch from '../PropertyCard/PropertyCardSearch';
import Loading from '../Loading/Loading';

class Properties extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let userFavourites = this.props.userFavourites;
    return (
      <div className="mt-5 mb-5">
        <h3 className="mb-2">Favourites</h3>
        {userFavourites.status == 'failure' ? <p>Something went wrong, please try again.</p> :
          userFavourites.status == 'success' ?
          userFavourites.favourites.length > 0 ?
            <div className={"mt-4 " + styles.resultGrid}>
              {userFavourites.favourites.map((fav, index) => (
                fav.property ? <PropertyCardSearch key={index} property={fav.property} isPropertyTracked={fav.isPropertyTracked} type="members" /> : null
              ))}
            </div>
          : <div className={"rounded p-4 " + styles.noItems}>Please add a property to your favourites list</div>
        : userFavourites.status == 'loading' || userFavourites.status == 'fetching' ? <Loading/> : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {userFavourites: state.userFavourites};
}
export default connect(mapStateToProps, null)(Properties);
